import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import moment from 'moment';
import config from '../../../../../config';
import Modal from '../../../../commons/Modal/Modal';
import { TextInputField, DateField, TextAreaField, BootstrapSelect } from '../../../../commons/Inputs';

let $ = window.jQuery;

export default class GalleryModal extends Component {
    static propTypes = {
        onNewImageUploaded: PropTypes.func.isRequired
    };

    state = {
        isSaving: false,
        uploadPercentage: 0,
        imageFields: [
            {
                index: 0,
                date: moment().format('MMMM DD, YYYY')
            }
        ],
        title: '',
        date: moment().format('MMMM DD, YYYY'),
        description: '',
        type: 'others'
    };

    handleCloseModal = () => {
        this.setState({
            isSaving: false,
            imageFields: [
                {
                    index: 0,
                    date: moment().format('MMMM DD, YYYY')
                }
            ],
            uploadPercentage: 0,
            type: 'others',
            title: '',
            date: moment().format('MMMM DD, YYYY'),
            description: ''
        });

        // Clear Images
        document.querySelector('.images').value = null;

    };

    handleClick = () => {
        this.setState({
            isSaving: true
        });

        this.uploadImage();
    };

    uploadImage = () => {
        let url = `${config.apiUrl}dental/galleries/${this.props.patientId}`;

        let data = new FormData();
        data.append('title', this.state.title);
        data.append('description', this.state.description);
        data.append('type', this.state.type === '' ? 'others' : this.state.type);
        data.append('date', this.state.date);

        let files = document.querySelectorAll('.images');

        for (let i = 0; i < files.length; i++) {
            data.append('documents['+i+']', files[i].files[0]);
        }

        let axiosConfig = {
            progress: (progressEvent) => {
                this.setState({
                    uploadPercentage: (progressEvent.loaded / progressEvent.total) * 100
                });
            }
        };

        axios.post(url, data, axiosConfig).then((res) => {
            $('#myModalXray').modal('hide');

            this.setState({
                isSaving: false,
                uploadPercentage: 0
            });

            this.props.showNotification('success', 'Saved Successfully');

            // Callback
            this.props.onNewImageUploaded(res.data.data);

            this.handleCloseModal();
        }).catch((res) => {
            $('#myModalXray').modal('hide');
            this.props.showNotification('error', 'Upload Failed. Please check your internet connection');

            this.setState({
                isSaving: false,
                uploadPercentage: 0
            });
        });
    };

    handleAddImageInput = (e) => {

        let target = e.target;
        if (e.target.classList.contains('fa')) {
            target = e.target.parentNode;
        }

        let childElem = target.childNodes[1];

        if (target.classList.contains('add')) {
            // eslint-disable-next-line
            let currentIndex = parseInt(this.state.imageFields[this.state.imageFields.length - 1].index);

            let imageField = {
                index: currentIndex + 1,
                date: moment().format('MMMM DD, YYYY')
            };

            this.setState({
                imageFields: this.state.imageFields.concat([imageField])
            }, () => {
                console.log(this.state.imageFields);
            });

            // Change flag
            target.classList.remove('add');
            target.classList.add('remove');

            // Change button color
            target.classList.remove('blue');
            target.classList.add('red');

            // Change button icon
            childElem.classList.remove('fa-plus');
            childElem.classList.add('fa-times');

        } else if (target.classList.contains('remove')) {
            // Get the item index
            let key = target.dataset.key;
            let classContainer = `image-container-${key}`;

            document.querySelector(`.${classContainer}`).remove();

            // cache imageFields state
            let imageFields = this.state.imageFields;

            // Check if imageFields already 0
            if (imageFields.length <= 0) {
                return;
            }

            // Find the index
            let imageIndex = imageFields.findIndex((item) => {
                // eslint-disable-next-line
                return item.index == key;
            });

            if (imageIndex < 0) {
                return;
            }

            this.setState({
                imageFields
            });

        }
    };

    docDateChangeHandler = (e, index) => {
        let fileIndex = this.state.imageFields.findIndex((item, i) => {
            return item.index === index;
        });

        let imageFields = this.state.imageFields;
        imageFields[fileIndex].date = e.target.value;

        this.setState({
            imageFields
        });
    };

    handleImageSelected = (e) => {
        // let fileReader = new FileReader();

        // fileReader.onloadend = function() {
        //
        //     let exif = EXIF.readFromBinaryFile(new BinaryFile(this.result));
        //
        //     switch(exif.Orientation) {
        //
        //         case 8:
        //             ctx.rotate(90*Math.PI/180);
        //             break;
        //         case 3:
        //             ctx.rotate(180*Math.PI/180);
        //             break;
        //         case 6:
        //             ctx.rotate(-90*Math.PI/180);
        //             break;
        //     }
        // };
    };

    imageInputField = (fileInput, i) => {
        return (
            <div className={`image_group_container row image-container-${fileInput.index}`} key={i}>
                <div className="col-md-5">
                    <div className="form-group form-md-line-input">
                        <input type="file" className='form-control images' id="images"
                               accept="image/*"
                               name="documents[]" onChange={this.handleImageSelected} />

                        <label htmlFor={this.props.id}>{this.props.label}</label>
                    </div>
                </div>

                <div className="col-md-5">
                    <DateField val={fileInput.date} id={`imageDate-${i}`}
                               label="Date Taken" help="Select date taken"
                               onChange={(e) => this.docDateChangeHandler(e, fileInput.index)} />
                </div>

                <div className="col-sm-2">
                    {/*<i className="fa fa-plus-circle fa-3x font-blue"*/}
                       {/*onClick={this.handleAddImageInput}*/}
                       {/*style={{ cursor: 'pointer', marginTop: '17px' }} />*/}

                    <div className="input-group-btn btn-right" style={{ paddingTop: '20px' }}>
                        <button type="button" className={"btn btn-circle btn-icon-only blue add"}
                           data-key={fileInput.index} onClick={this.handleAddImageInput}>

                            <i className="fa fa-plus" />
                        </button>
                    </div>
                </div>
            </div>
        )
    };

    componentDidMount() {
        this.setState({
            type: this.props.selectedCategory
        }, () => {
            $('#documentType').selectpicker('val', this.state.type);
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            type: nextProps.selectedCategory
        }, () => {
            $('#documentType').selectpicker('val', this.state.type);
        });
    }

    render() {

        let types = [
            {
                value: '',
                label: 'Select Document Type...'
            },
            {
                value: 'xray',
                label: 'X-Ray'
            },
            {
                value: 'before-after',
                label: 'Before and After'
            },
            {
                value: 'videos',
                label: 'Videos'
            },
            {
                value: 'others',
                label: 'Others'
            }
        ];

        if (this.state.type !== 'before-after') {
            return (
                <Modal id="myModalXray" header="Add Xray"
                       positiveButton="Save" negativeButton="Cancel"
                       width="600"
                       onPositiveClickEvent={this.handleClick}
                       onNegativeClickEvent={this.handleCloseModal}
                       isSaving={this.state.isSaving}>

                    <form id="addFormXray" method="POST" encType="multipart/form-data">
                        <div className="progress progress-striped active"
                             style={{ display: (this.state.uploadPercentage > 0) ? 'block' : 'none' }}>

                            <div className="progress-bar progress-bar-primary" role="progressbar"
                                 aria-valuenow={this.state.uploadPercentage} aria-valuemin="0"
                                 aria-valuemax="100" style={{ width: this.state.uploadPercentage+'%' }}>

                                <span className="sr-only"> Uploading... </span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <BootstrapSelect id="documentType" label="Document Type *"
                                                 help="Select document type..."
                                                 val={this.state.type}
                                                 onChange={(e) => {this.setState({type: e.target.value})}}
                                                 options={types} />
                            </div>
                        </div>

                        <div className="row">
                            <div id="alert-xray-container" className="col-md-12"
                                 style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>

                            <div className="col-md-6 col-sm-12">
                                <TextInputField val={this.state.title} id="title"
                                                label="Title"
                                                help="Type a title for this document"
                                                onChange={(e) => { this.setState({title: e.target.value}) }} />
                            </div>

                            <div className="col-md-6 col-sm-12">
                                <DateField val={this.state.date} id="dateField"
                                           label="Date" help="Select date taken"
                                           onChange={(e) => { this.setState({date: e.target.value}) }} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <TextAreaField val={this.state.description} id="description"
                                               label="Description"
                                               help="Type a description for this document"
                                               onChange={(e) => { this.setState({description: e.target.value}) }} />
                            </div>
                        </div>

                        <div className="image_group_container row">
                            <div className="col-md-12">
                                <div className="form-group form-md-line-input">
                                    <input type="file" className='form-control images' id="images"
                                           accept="image/*"
                                           name="documents[]" onChange={this.handleImageSelected} />

                                    <label htmlFor={this.props.id}>{this.props.label}</label>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal>
            )
        }

        return (
            <Modal id="myModalXray" header="Add Xray"
                   positiveButton="Save" negativeButton="Cancel"
                   width="900"
                   onPositiveClickEvent={this.handleClick}
                   onNegativeClickEvent={this.handleCloseModal}
                   isSaving={this.state.isSaving}>

                <form id="addFormXray" method="POST" encType="multipart/form-data">
                    <div className="progress progress-striped active"
                         style={{ display: (this.state.uploadPercentage > 0) ? 'block' : 'none' }}>

                        <div className="progress-bar progress-bar-primary" role="progressbar"
                             aria-valuenow={this.state.uploadPercentage} aria-valuemin="0"
                             aria-valuemax="100" style={{ width: this.state.uploadPercentage+'%' }}>

                            <span className="sr-only"> Uploading... </span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <BootstrapSelect id="documentType" label="Document Type *"
                                             help="Select document type..."
                                             val={this.state.type}
                                             onChange={(e) => {this.setState({type: e.target.value})}}
                                             options={types} />
                        </div>
                    </div>

                    <div className="row">
                        <div id="alert-xray-container" className="col-md-12"
                             style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>

                        <div className="col-md-6 col-sm-12">
                            <TextInputField val={this.state.title} id="title"
                                            label="Title"
                                            help="Type a title for this document"
                                            onChange={(e) => { this.setState({title: e.target.value}) }} />
                        </div>

                        <div className="col-md-6 col-sm-12">
                            <DateField val={this.state.date} id="dateBefore"
                                       label="Date" help="Select date taken"
                                       onChange={(e) => { this.setState({date: e.target.value}) }} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <TextAreaField val={this.state.description} id="description"
                                           label="Description"
                                           help="Type a description for this document"
                                           onChange={(e) => { this.setState({description: e.target.value}) }} />
                        </div>
                    </div>

                    {this.state.imageFields.map((fileInput, i) => {
                        return this.imageInputField(fileInput, i)
                    })}
                </form>
            </Modal>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Gallery/Modals/GalleryModal.js
 **/